

import { BMP_MonthlyInvestment } from "../models/bmp.model";
import { responseHero } from "../utils/axiosInterceptor";

export const getBMPLiquidityList = () : Promise<BMP_MonthlyInvestment[]> => {
    return new Promise<BMP_MonthlyInvestment[]>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/bmp/deposit/liquiditylist`).then((response) => {
            resolve(response.data as BMP_MonthlyInvestment[]);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};